exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1Tr6FjsZgxQfbTQcYj5eWk {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n._1U0R5gcmtpgF3QtS5axKOV {\n    max-width: 160px;\n    max-height: 324px;\n    margin-top: 20px;\n}", ""]);

// exports
exports.locals = {
	"root": "_1Tr6FjsZgxQfbTQcYj5eWk",
	"image": "_1U0R5gcmtpgF3QtS5axKOV"
};